(function () {
  'use strict';

  var source = document.currentScript;
  var root = source && source.getAttribute('data-by-store-root');
  root = root || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  root = root.replace(/\/+$/, '');
  var labels = (window.BikiniYesTranslations && window.BikiniYesTranslations.labelMap) || {};
  var localizedPath = /^\/(?:fr|it|de|el|ga|pl|pt)(?:\/|$)/i;
  var storefrontPath = /^\/(?:collections|products|pages|blogs|policies|search|cart)(?:\/|$)/;

  function isLanguageChoice(anchor) {
    return anchor.hasAttribute('hreflang') || anchor.hasAttribute('lang') ||
      anchor.closest('[data-localization-form],m-localization-form,.m-language-switcher');
  }

  function localizeLink(anchor) {
    if (isLanguageChoice(anchor)) return;
    var value = anchor.getAttribute('href');
    if (!value || value.charAt(0) === '#') return;
    var target;
    try { target = new URL(value, window.location.href); } catch (error) { return; }
    if (target.origin !== window.location.origin) return;
    var canonicalPath = target.pathname.replace(/\/policies\/return-policy\/?$/, '/policies/refund-policy');
    if (canonicalPath !== target.pathname) {
      target.pathname = canonicalPath;
      value = target.pathname + target.search + target.hash;
      anchor.setAttribute('href', value);
    }
    if (localizedPath.test(target.pathname)) return;
    if (target.pathname !== '/' && !storefrontPath.test(target.pathname)) return;
    if (!root) return;
    var path = target.pathname === '/' ? root : root + target.pathname;
    var replacement = path + target.search + target.hash;
    if (value !== replacement) anchor.setAttribute('href', replacement);
  }

  function localizeNavigationLabel(anchor) {
    if (isLanguageChoice(anchor) || !anchor.closest('header,footer,m-footer,nav,.m-menu-drawer')) return;
    var walker = document.createTreeWalker(anchor, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue;
      var label = text.trim().replace(/\s*[↗→]\s*$/, '').trim();
      var translated = labels[label.toLowerCase()];
      if (label && translated && translated !== label) node.nodeValue = text.replace(label, translated);
    }
  }

  function processAnchor(anchor) {
    localizeLink(anchor);
    localizeNavigationLabel(anchor);
  }

  function scan(scope) {
    if (scope.nodeType === 1 && scope.matches('a[href]')) processAnchor(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('a[href]').forEach(processAnchor);
  }

  function start() {
    scan(document);
    new MutationObserver(function (changes) {
      changes.forEach(function (change) {
        if (change.type === 'attributes') {
          processAnchor(change.target);
        } else {
          change.addedNodes.forEach(function (node) { if (node.nodeType === 1) scan(node); });
        }
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
